import React from 'react';
import { FiEye, FiPlusCircle, FiCreditCard } from 'react-icons/fi';
import DashboardCardGrid from '../components/DashboardCardGrid';

const INVOICE_CARD_DATA = [
  {
    title: 'View Invoice',
    description: 'Browse issued and draft invoices, open details, and download PDFs.',
    path: '/invoice/view',
    icon: <FiEye size={28} />,
    accent: '#10b981',
  },
  {
    title: 'Create Service Invoice',
    description: 'Build a tax invoice model and download as PDF or Word — nothing is saved.',
    path: '/invoice/create-service-invoice',
    icon: <FiPlusCircle size={28} />,
    accent: '#0ea5e9',
  },
  {
    title: 'Create Payment Invoice',
    description: 'Create a payment invoice for a customer.',
    path: '/invoice/create-payment-invoice',
    icon: <FiCreditCard size={28} />,
    accent: '#0d9488',
  },
];

export default function InvoiceCardPage() {
  return (
    <DashboardCardGrid
      pageTitle="Invoice"
      pageSubtitle="View existing invoices or create a new one."
      cardData={INVOICE_CARD_DATA}
      filterByRole={false}
    />
  );
}
